import React from "react";
import Icon from "feather-icons-react";
import { QtCheck, QtChevronRight } from "../../components/icons/QtIcon";

const MODULE_ICON_MAP = {
  shield: "shield",
  truck: "truck",
  package: "package",
  users: "users",
  map: "map",
  clipboard: "clipboard",
};

const LESSON_ICON_MAP = {
  video: "play-circle",
  text: "file-text",
  download: "download",
  image: "image",
};

export function AcademyModuleIcon({ name, size = 22, className = "" }) {
  const icon = MODULE_ICON_MAP[name] || "book-open";
  return (
    <Icon
      icon={icon}
      size={size}
      className={`training-icon ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export function AcademyLessonTypeIcon({ type, size = 14, className = "" }) {
  const icon = LESSON_ICON_MAP[type] || "circle";
  return (
    <Icon
      icon={icon}
      size={size}
      className={`training-icon training-icon-inline ${className}`.trim()}
      aria-hidden="true"
    />
  );
}

export function AcademyCheckIcon({ size = 14, className = "" }) {
  return <QtCheck size={size} className={className} />;
}

export function AcademyChevronIcon({ size = 18, className = "" }) {
  return <QtChevronRight size={size} className={`training-icon training-icon-chevron ${className}`.trim()} />;
}
